import React from 'react';
import { LocationBlock } from '../../components/LocationBlock';
export function SummerCampLocation() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-3257">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3258">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-3259">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-3260">
            Summer Camp in Farmington Hills, MI
          </h2>
          <p className="text-xl text-gray-warm" data-id="element-3261">
            Storm Taekwondo is located in Farmington Hills and serves families
            from nearby communities including Novi, Commerce, Walled Lake,
            Wixom, Livonia, Farmington, Waterford and Northville.
          </p>
        </div>
        <LocationBlock data-id="element-3262" />
      </div>
    </section>;
}